import React, { Component } from "react";

import Box from '@material-ui/core/Box';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';

class Alerter extends Component {
	constructor(props) {
        super(props);
    }

	render() {
				
		return (
		<Box>
			<NotificationsActiveOutlinedIcon style={{ fontSize: "22px", color: "#F00", cursor: "pointer" }} onClick={() => {  }}/> [{this.props.alertCount}] <a href="http://logs.eclanguages.eu" target="_blank">Tasks</a>
		</Box>
		);
  }
};

export default Alerter;